export default __webpack_public_path__ + "static/media/header.d95e663e.jpg";